import {type ZodString} from 'zod';
import {isValidUrl} from '@netx/core-next/utils/url/isValidUrl';
import {SchemaValidationErrorLabel} from '../locales';

export const refineUrl = (s: ZodString) =>
	s.refine(
		(v) => {
			// empty/no value is a valid value, use required() to enforce presence
			return v == null || v == '' || isValidUrl(v);
		},
		{message: SchemaValidationErrorLabel.INVALID_VALUE},
	);
